const DESIGNER_ALIAS_REGEX = /^(?:designer_|match_)(.+)$/i;

export const normalizeDesignerAliasId = (
  value: unknown
): string | null => {
  if (typeof value !== "string") return null;
  const trimmed = value.trim();
  if (!trimmed) return null;

  const match = trimmed.match(DESIGNER_ALIAS_REGEX);
  if (!match) return trimmed;

  const suffix = match[1]?.trim();
  if (!suffix) return trimmed;

  return `designer_${suffix}`;
};

export const getDesignerAliasVariants = (value: unknown): string[] => {
  if (typeof value !== "string") return [];
  const trimmed = value.trim();
  if (!trimmed) return [];
  if (!DESIGNER_ALIAS_REGEX.test(trimmed)) {
    return [trimmed];
  }

  const normalized = normalizeDesignerAliasId(trimmed);
  if (!normalized) return [trimmed];

  const suffix = normalized.replace(/^designer_/i, "");
  return Array.from(
    new Set([
      trimmed,
      normalized,
      `Designer_${suffix}`,
      `match_${suffix}`,
      `Match_${suffix}`,
    ])
  );
};

export const areDesignerAliasesEquivalent = (
  left: unknown,
  right: unknown
): boolean => {
  const leftNormalized = normalizeDesignerAliasId(left);
  const rightNormalized = normalizeDesignerAliasId(right);

  if (!leftNormalized || !rightNormalized) return false;
  return leftNormalized.toLowerCase() === rightNormalized.toLowerCase();
};
